import Header from '../components/util/Header';
import { supabase } from '../supabaseClient';
import './Login.css';

const Login = () => {
    const handleGoogleOAuthSignIn = async () => {
        console.log('구글 인증 실행');
        await supabase.auth.signInWithOAuth({
          provider: 'google',
          options: {
            redirectTo: `${window.location.origin}/auth/callback?mode=signin` 
          }
        });
      };

      const handleGoogleOAuthSignUp = async () => {
        console.log('구글 인증 실행');
        await supabase.auth.signInWithOAuth({
          provider: 'google',
          options: {
            redirectTo: `${window.location.origin}/auth/callback?mode=signup` 
          }
        });
      };
      
      return (
          <div className="page-login">
            <Header useLogo={false} left="back" title="" rightIcon1="" rightIcon2="" rightIcon3=""/>

            <div className="container">

              <h1>일상의 즐거움<br/>
                <span>CokePLAY</span>를 지금 시작해보세요!
              </h1>

              <button onClick={handleGoogleOAuthSignIn} type="button" className="google-oauth-button">
                <img src="/google_logo.png" alt=""/>
                <span>구글로 로그인<br/><small>sign in with Google</small></span>
              </button>

              <button onClick={handleGoogleOAuthSignUp} type="button" className="google-oauth-button">
                <img src="/google_logo.png" alt=""/>
                <span>구글로 회원가입<br/><small>sign up with Google</small></span>
              </button>  
            </div>

          </div>
      );
}

export default Login;